import { render, staticRenderFns } from "./ProductDeliveryInfo2.vue?vue&type=template&id=7cb3a2dc&"
import script from "./ProductDeliveryInfo2.vue?vue&type=script&lang=ts&"
export * from "./ProductDeliveryInfo2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports